import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ScheduleStatusInitStore = {
  hasFetched: boolean;
  setHasFetched: (value: boolean) => void;
  reset: () => void;
};

export const useScheduleStatusInitStore = create<ScheduleStatusInitStore>()(
  persist(
    (set) => ({
      hasFetched: false as boolean,
      setHasFetched: (value) => set({ hasFetched: value }),
      reset: () => set({ hasFetched: false }),
    }),
    { name: 'employee-management-schedule-status-init-store' }
  )
);
